import React from 'react';
import { Gift as GiftIcon, ArrowRight } from 'lucide-react';
import { Gift } from '../types';
interface GiftCardProps {
  gift: Gift;
  onClick: () => void;
}
export function GiftCard({
  gift,
  onClick
}: GiftCardProps) {
  const isRedeemed = gift.status === 'redeemed';
  return <div onClick={onClick} className={`
        relative overflow-hidden rounded-2xl p-5 text-white shadow-lg cursor-pointer transition-transform active:scale-[0.98]
        ${isRedeemed ? 'bg-gray-800' : 'bg-gradient-to-br from-purple-600 to-indigo-700'}
      `} data-id="element-102">
      {/* Background Pattern */}
      <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 bg-white/10 rounded-full blur-2xl" data-id="element-103" />
      <div className="absolute bottom-0 left-0 -ml-8 -mb-8 w-32 h-32 bg-black/10 rounded-full blur-2xl" data-id="element-104" />

      <div className="relative z-10" data-id="element-105">
        <div className="flex items-start gap-4 mb-4" data-id="element-106">
          {/* Product Image */}
          <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm overflow-hidden border-2 border-white/30 flex-shrink-0" data-id="element-107">
            <img src={gift.itemImage} alt={gift.itemName} className="w-full h-full object-cover" data-id="element-108" />
          </div>

          <div className="flex-1 min-w-0" data-id="element-109">
            <p className="font-bold text-lg leading-tight mb-1" data-id="element-110">
              {gift.itemName}
            </p>
            <p className="text-sm text-white/80" data-id="element-111">{gift.storeName}</p>
            <p className="text-lg font-bold mt-2" data-id="element-112">
              ${gift.itemPrice.toFixed(2)}
            </p>
          </div>

          <span className={`
            text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider flex-shrink-0
            ${isRedeemed ? 'bg-gray-700 text-gray-300' : 'bg-[#FFFC00] text-purple-900'}
          `} data-id="element-113">
            {isRedeemed ? 'Redeemed' : 'Active'}
          </span>
        </div>

        {gift.message && <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 mb-3" data-id="element-114">
            <p className="text-xs text-white/60 mb-1" data-id="element-115">From {gift.sender}</p>
            <p className="text-sm italic line-clamp-2" data-id="element-116">"{gift.message}"</p>
          </div>}

        <div className="flex justify-between items-center pt-3 border-t border-white/20" data-id="element-117">
          <p className="text-xs text-white/60" data-id="element-118">{gift.date}</p>
          {!isRedeemed && <ArrowRight size={18} className="text-white/80" data-id="element-119" />}
        </div>
      </div>
    </div>;
}